// extracted by mini-css-extract-plugin
export default {"root":"PaperSaveLoader_root__cPGvk","loader":"PaperSaveLoader_loader__41Q13"};